import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-black-card-style5',
  templateUrl: './black-card-style5.component.html',
  styleUrls: ['./black-card-style5.component.css']
})
export class BlackCardStyle5Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
